import { Style, Fill, Stroke, Circle, Icon } from 'ol/style';
import StrokePattern from "ol-ext/style/StrokePattern";
import IconAnchorUnits from 'ol/style/IconAnchorUnits';
import { IStyleCache, CoreLayerConfig, SymbologyItem } from '../../Models/MapConfigModels';
import { Feature } from 'ol';
import VectorLayer from 'ol/layer/Vector';

export class InfraMapStyles {
    // Private variables
    private wfsAttributeNames: Array<string> = [];

    private defaultOverrideStyle = new Style({ stroke: new Stroke({ color: 'rgba(241, 171, 0, 1)', width: 2 }), fill: new Fill({ color: 'rgba(132, 71, 15, 0.4)' }) , image: new Icon({ anchor: [12, 12], anchorXUnits: IconAnchorUnits.PIXELS, anchorYUnits: IconAnchorUnits.PIXELS, src: "/icons/Infra/other.png" }) });
    private defaultWithIssuesStyle = new Style({ image: new Icon({ anchor: [-5, 18], anchorXUnits: IconAnchorUnits.PIXELS, anchorYUnits: IconAnchorUnits.PIXELS, src: '/icons/IssueIcon/maint_yellow16.png', }) });
    private defaultHistoricStyle = new Style({ image: new Icon({ anchor: [8, 7], anchorXUnits: IconAnchorUnits.PIXELS, anchorYUnits: IconAnchorUnits.PIXELS, src: '/icons/InfraHistoric.png', }) });

    // Public variables
    public infraStyleCache: Array<IStyleCache> = [];

    // INIT
    public init(config: Array<CoreLayerConfig>) {
        const self = this;

        self.infraStyleCache = [];
        config.forEach(c => {
            if (c.symbologyItem != null) {
                c.symbologyItem.forEach(i => {
                    var s = self.setStyle(c.symbologyKey, i);
                    self.infraStyleCache.push(s);
                });
 
            }
        });
    }

    public infraStyleFunction = (feature: Feature, resolution, vectorLayer: VectorLayer, self): Style[] => {
        const hasIssues = feature.get('HasIssues');
        const historic = feature.get('Historic');
        const me: InfraMapStyles = self == null ? this : self.mapStyles.InfraMapStyles; // This is because the function is being called through OpenLayers, so seld refers to MapLayerHelper

        var styles: Array<Style> = [];

        // Search wfsAttributes
        const symbologyKey = vectorLayer.get('symbologyKey');
        var styleCache;
        if (symbologyKey != null) styleCache = me.infraStyleCache.filter(s => s.symbologyKey == symbologyKey);
        else styleCache = me.infraStyleCache;
   
        // Search wfsAttributes
        me.wfsAttributeNames.forEach(k => {
            var v = feature.get(k);
            if (v != null) {
                // Check to see if the wfsAttribute is mentioned in the style cache
                if (styleCache.find(s => s.wfsAttributeName == k) != null) {
                    // If the wfsAttribute is in the style cache, now check to see if the feature has that value
                    var s = styleCache.find(s => s.wfsAttributeName == k && s.attributeValue == v);
                    if (s != null) {
                        if (hasIssues == "1") {
                            styles.push(s.style, me.defaultWithIssuesStyle);
                        }
                        else if (historic == "1") {
                            var newStyle = (s.style as Style).clone();
                            newStyle.getImage().setOpacity(0.5);
                            styles.push(newStyle, me.defaultHistoricStyle);
                        }
                        else styles.push(s.style);
                    }
                }
            }
        });
        if (styles.length == 0) {
            var s = styleCache.find(f => f.attributeLabel.toLowerCase() == 'default');
            if (s != null) styles.push(s.style);
            if (styles.length == 0) styles.push(me.defaultOverrideStyle);
        }

        return styles;

    }

    private setStyle(symbologyKey: string, i: SymbologyItem): IStyleCache {
        var self = this;
        var s: IStyleCache = { symbologyKey: symbologyKey, wfsAttributeName: i.wfsAttributeName, attributeLabel: i.attributeLabel, attributeAltLabel: i.attributeAltLabel, attributeValue: i.attributeValue, showInLegend: i.showInLegend, style: null };

        var image = null; var stroke = null; var fill = null;
        if (i.image != null) {
            image = new Icon({ anchor: [12, 12], anchorXUnits: IconAnchorUnits.PIXELS, anchorYUnits: IconAnchorUnits.PIXELS, src: i.image.imageSource, });
            if (s.style == null) s.style = new Style();
            s.style.setImage(image);
        }

        if (i.stroke != null) {
            if (s.style == null) s.style = new Style();
            stroke = new Stroke({ color: i.stroke.strokeColor, width: i.stroke.width });
            if (i.stroke.fillColor != null) s.style.setFill(new Fill({ color: i.stroke.fillColor }));
            if (i.stroke.lineDash != null) {
                var ld = i.stroke.lineDash.split(",");
                if (ld && ld.length == 2) stroke.setLineDash(ld as any);
            }
            s.style.setStroke(stroke);
        }

        if (self.wfsAttributeNames.indexOf(s.wfsAttributeName) == -1) self.wfsAttributeNames.push(s.wfsAttributeName);

        return s;
    }
}




